import { DinMisstanke, VilkenSituation } from "@/store/types";

export function isFelaktigErsattningEnabled(
    misstanke: DinMisstanke,
    situation: VilkenSituation,
): boolean {
    if (
        misstanke === DinMisstanke.FORETAG &&
        situation === VilkenSituation.FORETAG_ANNAN
    ) {
        return true;
    }
    const choices = [
        VilkenSituation.ARBETAR_SAMTIDIGT,
        VilkenSituation.SAMMANBOENDE,
        VilkenSituation.FLYTT_UTOMLANDS,
        VilkenSituation.PRIVAT_ANNAN,
    ];
    if (
        misstanke === DinMisstanke.PRIVATPERSON &&
        choices.includes(situation)
    ) {
        return true;
    }
    return false;
}
